module.exports = __webpack_public_path__ + "assets/alarmicon2.42754c2b.svg";